import { createContext, type PropsWithChildren, useContext } from 'react';

export const createExperiment = <T,>(defaultExperiments: T | undefined = undefined) => {
    interface Props {
        experiments: T | undefined;
    }

    const ExperimentContext = createContext<T | undefined>(defaultExperiments);

    const ExperimentProvider = ({ experiments, children }: PropsWithChildren<Props>) => (
        <ExperimentContext.Provider value={experiments}>{children}</ExperimentContext.Provider>
    );

    const useExperiment = (): T | undefined => useContext(ExperimentContext);

    return {
        ExperimentProvider,
        useExperiment,
    };
};
